/* global axios */
import AsteriskApiClient from './index';

class TrunksAPI extends AsteriskApiClient {
  constructor() {
    super('trunks');
  }

  // GET /api/v1/accounts/:account_id/asterisk/trunks
  get() {
    return axios.get(this.url);
  }

  // GET /api/v1/accounts/:account_id/asterisk/trunks/:trunk_name
  show(trunkName) {
    return axios.get(`${this.url}/${encodeURIComponent(trunkName)}`);
  }

  // POST /api/v1/accounts/:account_id/asterisk/trunks
  create(data) {
    return axios.post(this.url, data);
  }

  // PUT /api/v1/accounts/:account_id/asterisk/trunks/:trunk_name
  update(trunkName, data) {
    return axios.put(`${this.url}/${encodeURIComponent(trunkName)}`, data);
  }

  // DELETE /api/v1/accounts/:account_id/asterisk/trunks/:trunk_name
  delete(trunkName) {
    return axios.delete(`${this.url}/${encodeURIComponent(trunkName)}`);
  }
}

export default new TrunksAPI();
